<script setup lang="ts">
import TypographyComponent from '../../atoms/TypographyComponent.vue'

defineProps<{ hashtags: string[] }>()
</script>
<template>
  <div v-if="hashtags.length" class="campaign-hashtags">
    <TypographyComponent v-for="hashtag in hashtags" :key="hashtag" variant="label-large" class="campaign-hashtags__item">
      #{{ hashtag }}
    </TypographyComponent>
  </div>
</template>
<style lang="scss" scoped>
.campaign-hashtags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border: 1px solid var(--secondary-8);
  border-radius: 16px;
}
.campaign-hashtags__item {
  color: var(--primary);
}
</style>
